import React from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import queryString from 'query-string';
import WelcomeModal from './WelcomeModal';
import * as homeActions from '../../common/homeActions';

const isClient = typeof window !== 'undefined';

type Props = {
  // Redux state
  home: any,
  // Redux homeActions
  markModalSeen: typeof homeActions.markModalSeen,
};

export const AddedBusinessHandlerComponent = ({
  home,
  markModalSeen,
}: Props): any => {
  const addedBusiness = isClient && queryString.parse(window.location.search).addedBusiness;
  return (
    <If condition={addedBusiness && !home.viewedWelcomeModal[addedBusiness]}>
      <WelcomeModal
        spId={addedBusiness}
        onRequestHide={() => markModalSeen(addedBusiness)}
      />
    </If>
  );
};

export default (compose(
  connect(state => ({
    home: state.home,
  }), homeActions),
  pure,
)(AddedBusinessHandlerComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/AddedBusinessHandler.js